import type {
  TCreateExportConfigDTO,
  TGetExportConfigDTO,
  TGetExportDTO,
  TUpdateExportConfigDTO,
} from '@conversed/shared/src/central/dto/export.dto';

import { ENDPOINTS } from '../constants/apiEndpoints';
import { axiosInterceptAccessTokenExpiry } from './axios/axiosIntercepted';
import type { TGeneralResponse } from './dto/common.dto';

export const getExportsApi = (path?: string): TGeneralResponse<TGetExportDTO> =>
  axiosInterceptAccessTokenExpiry().get(
    `${ENDPOINTS.EXPORTS.EXPORTS}/${path ?? ''}`,
  );

export const getExportApi = (path: string): TGeneralResponse<BlobPart> =>
  axiosInterceptAccessTokenExpiry().get(`/media/${path}`);

export const deleteExportApi = (path: string): TGeneralResponse =>
  axiosInterceptAccessTokenExpiry().delete(
    `${ENDPOINTS.EXPORTS.EXPORTS}/${path ?? ''}`,
  );

export const getExportConfigApi = (): TGeneralResponse<TGetExportConfigDTO[]> =>
  axiosInterceptAccessTokenExpiry().get(ENDPOINTS.EXPORTS.CONFIG);

export const removeExportConfigApi = (id: string): TGeneralResponse =>
  axiosInterceptAccessTokenExpiry().delete(`${ENDPOINTS.EXPORTS.CONFIG}/${id}`);

export const changeExportConfigStatusApi = (id: string, status: boolean) =>
  axiosInterceptAccessTokenExpiry().put(
    `${ENDPOINTS.EXPORTS.CONFIG_STATUS}/${id}`,
    { status },
  );

export const createExportConfigApi = (exportConfig: TCreateExportConfigDTO) =>
  axiosInterceptAccessTokenExpiry().post(`${ENDPOINTS.EXPORTS.CONFIG}`, {
    ...exportConfig,
  });

export const updateExportConfigApi = (exportConfig: TUpdateExportConfigDTO) =>
  axiosInterceptAccessTokenExpiry().put(
    `${ENDPOINTS.EXPORTS.CONFIG}/${exportConfig.id}`,
    {
      ...exportConfig,
    },
  );
